// API Configuration
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_BASE_URL = (process.env.REACT_APP_API_URL)
    ? process.env.REACT_APP_API_URL
    : (isLocal ? 'http://localhost:5002' : ''); // Use relative path in production if no ENV is set

export const API_CONFIG = {
    BASE_URL: API_BASE_URL,
    ENDPOINTS: {
        // Admin endpoints
        ADMIN_LOGIN: `${API_BASE_URL}/api/admin/login`,
        ADMIN_STATS: `${API_BASE_URL}/api/admin/stats`,
        ADMIN_USERS: `${API_BASE_URL}/api/admin/users`,
        ADMIN_ADMINS: `${API_BASE_URL}/api/admin/admins`,
        ADMIN_LOANS: `${API_BASE_URL}/api/admin/loans`,
        ADMIN_TICKETS: `${API_BASE_URL}/api/admin/tickets`,
        ADMIN_ANALYTICS: `${API_BASE_URL}/api/admin/analytics`,
        ADMIN_PERMISSIONS: `${API_BASE_URL}/api/admin/permissions`,
        ADMIN_ROLES: `${API_BASE_URL}/api/admin/roles`,
        ADMIN_ACTIVITY: `${API_BASE_URL}/api/admin/activity`,
        ADMIN_CREATE_ADMIN: `${API_BASE_URL}/api/admin/create-admin`,
        ADMIN_CREATE_USER: `${API_BASE_URL}/api/admin/create-user`,
        ADMIN_IMPERSONATE: `${API_BASE_URL}/api/admin/impersonate`,
        ADMIN_SUPPORT_TICKETS: `${API_BASE_URL}/api/admin/support/tickets`,
        ADMIN_SUPPORT_ASSIGN: `${API_BASE_URL}/api/admin/support/assign`,
        ADMIN_SUPPORT_RESOLVE: `${API_BASE_URL}/api/admin/support/resolve`,
        ADMIN_FORGOT_PASSWORD: `${API_BASE_URL}/api/admin/forgot-password`,
    }
};

export default API_CONFIG;
